import { comics } from '@/mocks/comics';
import { Link } from 'react-router-dom';

export default function FeaturedComics() {
  const featured = comics.filter((c) => c.featured);

  return (
    <section className="w-full px-4 md:px-6 py-10 md:py-14 bg-background-100">
      <div className="max-w-7xl mx-auto">
        <div className="flex items-center justify-between mb-8">
          <div>
            <h3 className="text-xl md:text-2xl font-heading font-bold text-foreground-900">
              强力推荐
            </h3>
            <p className="text-sm text-foreground-500 mt-1">编辑精选优质韩漫，不容错过的精彩</p>
          </div>
          <Link
            to="/category/love"
            onClick={() => window.scrollTo(0, 0)}
            className="text-sm text-primary-600 hover:text-primary-700 font-medium flex items-center gap-1 cursor-pointer whitespace-nowrap"
          >
            查看更多
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>
        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-5 gap-4 md:gap-5">
          {featured.map((comic) => (
            <Link
              key={comic.id}
              to={`/comic/${comic.id}`}
              onClick={() => window.scrollTo(0, 0)}
              className="group cursor-pointer"
              data-product-shop
            >
              <div className="relative aspect-[5/7] rounded-lg overflow-hidden mb-3 bg-background-200">
                <img
                  src={comic.cover}
                  alt={comic.title}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-300"
                />
                <div className="absolute top-2 left-2 px-2 py-0.5 bg-primary-500 text-background-50 text-xs font-medium rounded-md">
                  {comic.rating}分
                </div>
                {comic.status === '已完结' && (
                  <div className="absolute top-2 right-2 px-2 py-0.5 bg-accent-500 text-background-50 text-xs font-medium rounded-md">
                    已完结
                  </div>
                )}
              </div>
              <h4 className="text-sm font-medium text-foreground-900 group-hover:text-primary-600 transition-colors line-clamp-1">
                {comic.title}
              </h4>
              <p className="text-xs text-foreground-500 mt-1">
                {comic.author} · 更新至{comic.chapters}话
              </p>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}